import "./styles.sass";
import React, { FC, useContext, useEffect, useState } from "react";
import { Context } from "../../index";
import { ThemeContext } from "../../ThemeContext";
import logo from "../../assets/icons/logo.svg";
import themeBtn from "../../assets/icons/theme.svg";
import { NotificationIcon } from "../../assets/icons";
import avatar from "../../assets/images/admin-avatar.png";
import { Link } from "react-router-dom";
interface IHeader {
  position: string;
}

const Header: FC<IHeader> = ({ position }) => {
  const { store, users } = useContext(Context);
  const theme = useContext(ThemeContext);

  return (
    <header className={`header ${position} ${theme.theme}`}>
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <Link to="/" className="title">
        NG Loans
      </Link>
      <div className="controls">
        <button className="theme btn" onClick={theme.toggleTheme}>
          <img src={themeBtn} alt="change theme" className="icon" />
        </button>
        {store.isAuth && (
          <button className="notif btn">
            <NotificationIcon color="#041121" className="icon" />
          </button>
        )}
      </div>
      {store.isAuth && (
        <Link to="/profile" >
          <div className="admin">
            <div className="avatar">
              <img src={avatar} alt="avatar" />
            </div>
            <div className="name">{store.user.name}</div>
          </div>
        </Link>
      )}
    </header>
  );
};

export default Header;
